<div class="layout-wrapper" [ngClass]="containerClass">
  <p-toast></p-toast>
  <app-topbar [electionName]="electionName" [daysRemaining]="daysRemaining"></app-topbar>
  <app-sidebar [model]="model"></app-sidebar>
  <div class="layout-main-container">
      <div class="layout-main">
          <router-outlet></router-outlet>
      </div>
  </div>
  <div class="layout-mask animate-fadein"></div>
</div>